<div class="mb-4" *ngFor="let entry of entries">
  <div class="row mb-1">
    <div class="col-8 col-md-10 d-flex align-items-center">
      <p class="secondary-paragraph word-break">
        {{ entry.name }}
      </p>
    </div>
    <div class="col-4 col-md-2 d-flex align-items-end justify-content-end">
      <span class="range-quantity heading-4">
        {{ entry.range }}
      </span>
    </div>
  </div>
  <input [disabled]="isDisabled" [ngClass]="{'custom-range-disabled': isDisabled}"  class="" type="range" [(ngModel)]="entry.range" min="0" max="{{ rangeCriteria }}"
    step="1" (input)="calculateTotal()">
</div>
